import { ref, readonly } from 'vue'
import axios from 'axios'

// Estado global compartilhado entre componentes
const sistemas = ref(['DIETSYSTEM', 'DOCTORALIA', 'WEBDIET', 'OUTROS'])
const carregado = ref(false)
const carregando = ref(false)

/**
 * Composable para gerenciar sistemas inscritos
 * Busca da API e mantém cache local
 */
export function useSistemasInscritos() {

  async function carregar() {
    if (carregado.value || carregando.value) return sistemas.value

    carregando.value = true
    try {
      const response = await axios.get('/api/sistemas-inscritos/nomes')
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        sistemas.value = response.data
        carregado.value = true
      }
    } catch (error) {
      console.warn('Erro ao carregar sistemas inscritos, usando fallback:', error.message)
    } finally {
      carregando.value = false
    }

    return sistemas.value
  }

  function recarregar() {
    carregado.value = false
    return carregar()
  }

  return {
    sistemas: readonly(sistemas),
    carregado: readonly(carregado),
    carregando: readonly(carregando),
    carregar,
    recarregar,
  }
}

// Valores padrão exportados para uso direto
export const SISTEMA_PADRAO = 'DIETSYSTEM'
